// Boş / yükleniyor / hata state'leri için ortak yüzey — M9-S2.
// Her sayfa için inline render yerine tek pattern. FilteredTable ve liste sayfaları kullanır.

import type { ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  hint?: string;
  action?: ReactNode;
}

export function EmptyState({ title, hint, action }: EmptyStateProps): JSX.Element {
  return (
    <div
      role="status"
      style={{
        padding: "48px 24px",
        textAlign: "center",
        color: "var(--color-text-3)",
        fontSize: "0.9rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: "var(--color-bg)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          color: "var(--color-text-3)",
          marginBottom: 4,
        }}
      >
        ∅
      </div>
      <div style={{ fontWeight: 500, color: "var(--color-text-2)" }}>{title}</div>
      {hint ? <div style={{ maxWidth: 420 }}>{hint}</div> : null}
      {action ? <div style={{ marginTop: 8 }}>{action}</div> : null}
    </div>
  );
}

export function LoadingState({ label = "Yükleniyor…" }: { label?: string }): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        padding: "48px 24px",
        textAlign: "center",
        color: "var(--color-text-3)",
        fontSize: "0.9rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div
        aria-hidden="true"
        className="mahir-spinner"
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          border: "2px solid var(--color-border)",
          borderTopColor: "var(--color-primary)",
          animation: "mahir-spin 0.8s linear infinite",
        }}
      />
      <span>{label}</span>
    </div>
  );
}

export interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({
  title = "Yükleme başarısız",
  message,
  onRetry,
  retryLabel = "Yeniden dene",
}: ErrorStateProps): JSX.Element {
  return (
    <div
      role="alert"
      style={{
        padding: "40px 24px",
        textAlign: "center",
        color: "var(--color-text-2)",
        fontSize: "0.9rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          background: "color-mix(in srgb, var(--color-error) 10%, white)",
          color: "var(--color-error)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.1rem",
          fontWeight: 700,
        }}
      >
        !
      </div>
      <div style={{ fontWeight: 600, color: "var(--color-text)" }}>{title}</div>
      <div style={{ maxWidth: 520, color: "var(--color-text-3)" }}>{message}</div>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          style={{
            marginTop: 6,
            padding: "8px 18px",
            borderRadius: 8,
            background: "var(--color-primary)",
            color: "var(--color-surface)",
            border: "none",
            fontWeight: 600,
            fontSize: "0.85rem",
            cursor: "pointer",
          }}
        >
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}
